<template>
  <simple-tooltip v-if="credentials" tooltip="WEB-EL gästinloggning">
    <v-menu
      v-model="menuOpen"
      bottom
      right
      transition="scale-transition"
      origin="top left"
      max-height="600"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          small
          aria-label="WEB-EL gästinloggning"
          class="ml-2 px-2"
          style="min-width: 0;"
          v-bind="attrs"
          v-on="on"
          @click.stop
        >
          <img :src="garoLogo" alt="GARO" width="40">
        </v-btn>
      </template>
      <v-card max-width="600" class="py-0 px-4">
        <v-card-title class="pb-2">
          <span class="text-h6 font-weight-light">WEB-EL gästinloggning</span>
        </v-card-title>
        <v-card-text>
          <div class="text-subtitle-2">Platsnr./användarnamn</div>
          <div class="text-body-2 mb-4">{{ credentials.username }}</div>
          <div class="text-subtitle-2">Personlig kod</div>
          <div class="text-body-2">{{ credentials.password }}</div>
        </v-card-text>
      </v-card>
    </v-menu>
  </simple-tooltip>
</template>

<script>
import SimpleTooltip from '@/components/common/SimpleTooltip.vue'
import PositionService from '@/services/PositionService'
import garoLogo from '@/assets/images/garo-logo-red.webp'

export default {
  components: { SimpleTooltip },
  props: { booking: Object, isOpen: Boolean },
  data: () => ({ menuOpen: false, credentials: null, garoLogo }),
  computed: {
    position () { return this.$store.state.position.positions.find(position => position.id === this.booking?.position_id) },
    accountKey () {
      return this.isOpen && this.booking?.checked_in_at && !this.booking.checked_out_at && !this.booking.deleted_at && this.position?.has_webel_electric_meter ? `${this.booking.id}-${this.position.id}` : null
    }
  },
  watch: {
    accountKey: {
      immediate: true,
      async handler (key) {
        this.menuOpen = false
        this.credentials = null
        if (!key) { return }
        try {
          const { data } = await PositionService.getMeterCredentials(this.position.id, this.booking.id)
          if (this.accountKey === key && data.status === 'success') {
            this.credentials = data.data.credentials
          }
        } catch (_) {
          this.credentials = null
        }
      }
    }
  }
}
</script>
